import React from "react";

import { useAppTheme } from "hooks/useAppTheme";

type Props = {
  fill?: string;
};
export function UploadIcon({ fill }: Props) {
  const black = useAppTheme()?.palette?.black;
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.6875 9.75V3.12812L3.575 5.24062L2.4375 4.0625L6.5 0L10.5625 4.0625L9.425 5.24062L7.3125 3.12812V9.75H5.6875ZM0 13V8.9375H1.625V11.375H11.375V8.9375H13V13H0Z"
        fill={fill || black}
      />
    </svg>
  );
}
